'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { LecturerDetail } from '@eliadmin/core/src/api/courses/coursers-api';

import { CarouselSection } from '../shared/carousel-section';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { CarouselControls } from '@eliadmin/core/src/components/ui/carousel-controls';
import { CgArrowLeft, CgArrowRight } from 'react-icons/cg';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function CourseLecturerGallery({ lecturer }: { lecturer: LecturerDetail }) {
  const { t } = useTranslations();

  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />

      <CarouselSection
        subtitle={t('text2204')}
        title={t('text2210')}
        className={{
          section: 'bg-[#F6F6F6] py-12 sm:py-14 md:py-16 lg:py-16',
          heading_container: { heading: { title: 'text-black', subtitle: 'uppercase' } },
          carousel_container: {
            carousel: {
              container: 'gap-4 lg:gap-5',
              slide:
                'relative h-[550px] w-full max-w-[320px] sm:h-[600px] sm:max-w-[360px] lg:h-[640px]',
            },
          },
        }}
        slides={(lecturer.images ?? []).map((image, index) => (
          <button
            type="button"
            onClick={handleOpenGallery(lecturer.images ?? [], index)}
            key={image.name}
            aria-label={`${t('text2210')} – ${lecturer.name}, ${index + 1}`}
            className="absolute inset-0 z-0 h-full w-full border-0 bg-transparent p-0 text-left"
          >
            <Image
              src={image.url}
              alt={resolveImageAlt(image, 'Lektor')}
              width={0}
              height={0}
              className="absolute inset-0 z-0 h-full w-full cursor-pointer object-cover object-center transition-all hover:opacity-80"
              sizes="(min-width: 640px) 360px, 320px"
            />
          </button>
        ))}
      >
        <CarouselControls
          nextIcon={<CgArrowRight size={24} className="text-white" />}
          prevIcon={<CgArrowLeft size={24} className="text-white" />}
          className={{
            main: 'hidden items-center justify-end gap-4 md:flex',
            button:
              'min-h-14 min-w-14 bg-black !text-xl text-white hover:bg-black/95 hover:text-white',
          }}
        />
      </CarouselSection>
    </>
  );
}
